// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"202":"8a4514cf","219":"02c9225a","594":"471b8726","720":"4d550b7e"}[chunkId] + ".js";
};